<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.5 20C6.8075 20 6.25 19.4425 6.25 18.75L6.25 13.75L1.25 13.75C0.5575 13.75 0 13.1925 0 12.5L0 7.5C0 6.8075 0.5575 6.25 1.25 6.25L6.25 6.25L6.25 1.25C6.25 0.5575 6.8075 0 7.5 0L12.5 0C13.1925 0 13.75 0.5575 13.75 1.25L13.75 6.25L18.75 6.25C19.4425 6.25 20 6.8075 20 7.5L20 12.5C20 13.1925 19.4425 13.75 18.75 13.75L13.75 13.75L13.75 18.75C13.75 19.4425 13.1925 20 12.5 20L7.5 20ZM7.5 14.375H12.5L10 11.875L7.5 14.375ZM7.5 11.25H12.5L10 8.75L7.5 11.25ZM7.5 8.125H12.5L10 5.625L7.5 8.125Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "Heal",
};
</script>

<style scoped></style>
